/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} File_Export_Audio_Dubbing_AriaInputs */



/**
* | output |
* | --- |
* | "Export dubbed audio and video" |
*
* @param {File_Export_Audio_Dubbing_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const file_export_audio_dubbing_aria = /** @type {((inputs?: File_Export_Audio_Dubbing_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<File_Export_Audio_Dubbing_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Exporter l'audio doublé et la vidéo")
	if (locale === "de") return /** @type {LocalizedString} */ ("Synchronisierten Ton und Video exportieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Esporta audio doppiato e video")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Экспорт дублированного звука и видео")
	if (locale === "es") return /** @type {LocalizedString} */ ("Exportar audio doblado y video")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("导出配音音频和视频")
	if (locale === "ja") return /** @type {LocalizedString} */ ("吹き替え音声とビデオをエクスポートする")
	if (locale === "hi") return /** @type {LocalizedString} */ ("डब ऑडियो और वीडियो निर्यात करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Exportar áudio dobrado e vídeo")
	return /** @type {LocalizedString} */ ("Export dubbed audio and video")
});